
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class ReceiptService extends BaseApi {


    constructor(){
        super();
    }


    async list(business, filter)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/receipts${filter}`)
        .catch(this.handleErrorResponse);
    }


    async get(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/receipts/${id}`)
        .catch(this.handleErrorResponse);
    }

    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/receipts`, data)
        .catch(this.handleErrorResponse);
    }



    async update(business, id, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/receipts/${id}`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, id)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/receipts/${id}`)
        .catch(this.handleErrorResponse);
    }


    async pdf(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/receipts/${id}/pdf`,
        {
            responseType: "blob",
            headers:  { "Access-Control-Allow-Origin": "*" },
            exposedHeaders: ["Content-Disposition"],
        })
        .catch(this.handleErrorResponse);
    }


    async exportReceipts(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/receipts/export`,
        {
            responseType: "blob",
            headers:  { "Access-Control-Allow-Origin": "*" },
            exposedHeaders: ["Content-Disposition"],
        })
        .catch(this.handleErrorResponse);
    }
}